export class County {
    Key: string;
    Value: string;
}